import { httpClient } from '@/modules/common/services/http/http-client';

import { IPortfolioList } from '@/types/models/Portfolio';

export const http = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_URL
});

export function getPortfoliosToWithdraw(): Promise<IPortfolioList[]> {
  return http.get('/portfolios/v1/withdraw/list');
}
